import {
  Input,
  OnInit,
  Output,
  OnChanges,
  Component,
  EventEmitter,
  SimpleChanges,
} from '@angular/core';

import {
  ngHelper,
  PRODUCT_TYPE_STRUCTURE_TYPES,
  IProductTypeListMode,
} from '@cakeiteasy/web-utils';

import { ICakeCartLine } from '../../../cart';

@Component({
  standalone: false,
  selector: 'product-type-list',
  templateUrl: './product-type-list.component.html',
  styleUrls: ['./product-type-list.component.scss']
})
export class ProductTypeListComponent implements OnInit, OnChanges {
  @Input() products: IProductTypeListMode[];
  @Input() cartLines: ICakeCartLine[];
  @Input() showImages: boolean;

  @Output() saveLineToCart = new EventEmitter<{ cartLine: ICakeCartLine; productType: IProductTypeListMode }>();
  @Output() removeLineFromCart = new EventEmitter<ICakeCartLine>();
  @Output() removeVariantFromCart = new EventEmitter<ICakeCartLine>();
  @Output() showModal = new EventEmitter<{
    productType: IProductTypeListMode;
    orderLineBuilderId?: string;
    isEdit?: boolean;
  }>();
  @Output() showCart = new EventEmitter<void>();

  public productColumns: IProductTypeListMode[][] = [];

  public readonly STRUCTURE_TYPES = PRODUCT_TYPE_STRUCTURE_TYPES;

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    ngHelper.ifChanged(changes, 'products', (products: IProductTypeListMode[]) => {
      this._setProductColumns(products);
    });
  }

  private _setProductColumns(products: IProductTypeListMode[]) {
    this.productColumns = (products || []).reduce((acc, curr, index) => {
      if (index % 2 === 0) {
        acc[0].push(curr);
      } else {
        acc[1].push(curr);
      }
      return acc;
    }, [[], []]);
  }
}
